import { useMemo } from 'react';

interface UseGetTableDataProps<Table, Rows> {
  data: Rows | undefined;
  convertFn: (lookupResult: Rows, ...args: any) => Table[];
  extraArgs?: any;
}

/*
This custom hook sets table data source and return it.
It calculates the table data source with given data and convertFn function.
*/
const useGetTableData = <T, Y>({ data, convertFn, extraArgs }: UseGetTableDataProps<T, Y>) => {
  // const [tableDataSource, setTableDataSource] = useState<T[] | undefined>(undefined);

  const tableDataSource = useMemo(() => {
    if (!data) return [];
    return convertFn(data, extraArgs);
  }, [extraArgs, data, convertFn]);

  // useEffect(() => {
  //   if (data) {
  //     setTableDataSource(func(data, extraArgs));
  //   }
  // }, [data, convertFn, func]);

  return { tableDataSource };
};

export default useGetTableData;
